import { __assign } from "tslib";
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { skeletonCSS } from '../../common/styles';
var gridSize = gridSizeFn();
export var buttonHeight = gridSize * 4;
export var margin = {
    left: gridSize / 2,
};
export var padding = {
    all: gridSize / 2,
};
export var getPrimaryButtonTheme = function (_a) {
    var primaryButton = _a.mode.primaryButton;
    return function (current, props) {
        var _a = current(props), buttonStyles = _a.buttonStyles, spinnerStyles = _a.spinnerStyles;
        return {
            buttonStyles: __assign(__assign(__assign(__assign({}, buttonStyles), primaryButton.default), (props.isSelected && primaryButton.active)), { fontWeight: 500, padding: '0 4px', marginLeft: 0, marginRight: 0, ':hover': primaryButton.hover, ':focus': primaryButton.focus, 
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                '&&': __assign({}, (props.state === 'active' && primaryButton.active)) }),
            spinnerStyles: spinnerStyles,
        };
    };
};
export var primaryButtonSkeletonCSS = function (theme) { return (__assign({ borderRadius: gridSize / 2 + "px", display: 'inline-flex', height: buttonHeight - padding.all * 2.5 + "px", width: '68px' }, skeletonCSS(theme))); };
export var isHighlightedCSS = function (_a, isHighlighted) {
    var primaryButton = _a.mode.primaryButton;
    return (__assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', position: 'relative' }, (isHighlighted && {
        '&& > *': {
            color: primaryButton.selected.color,
        },
        '&:after': {
            position: 'absolute',
            bottom: 0,
            left: gridSize / 2,
            right: gridSize / 2,
            content: '""',
            height: 3,
            backgroundColor: primaryButton.selected.borderColor,
            borderTopLeftRadius: 1,
            borderTopRightRadius: 1,
        },
    })));
};
//# sourceMappingURL=styles.js.map